import angular from 'angular';
import messageShowModal from './messageShow.modal.html';

class historyMessageController {
  /* @ngInject */
  constructor(MessageOutboundService, $timeout, ModalFactory, NewTokenService) {
    let messages = [];
    let modal = undefined;

    this.loader = false;
    this.listing_mode = 'history';

    this.pagination = {
      currentPage: {
        number: 0,
        data: []
      },
      pageSize: 20
    };

    this.changePage = (page = 0) => {
      if (messages === undefined) return;
      if (angular.isArray(messages) && messages.length === 0) return;
      this.pagination.currentPage.number = page;
      const pageStart = page * this.pagination.pageSize;
      const pageEnd = pageStart + this.pagination.pageSize;
      this.pagination.currentPage.data = messages.slice(pageStart, pageEnd);
    };
    const loadMerchantProfile = () => {
      this.userContext = NewTokenService.getUserContext();
    };

    this.deleteMessage = ( message ) => {
      MessageOutboundService.deleteMessage(this.userContext, message.id).then((response) => {
        console.log( response );
        messages = response.response;
        this.pagination.elementsCount = messages.length;
        this.changePage();
      }).finally(() => {
        this.loader = false;
        init();
      });

    };

    this.openMessageShowModal = ( message ) => {
      message.content_type = message.content_type || "not_set";
      modal = new ModalFactory({
        overlay: true,
        overlayClose: false,
        template: messageShowModal,
        class: 'large',
        contentScope: {
          message: message,
          cancel: closeModal
        }
      });

      modal.activate();
    };
    const closeModal = () => {
      modal.deactivate();
      $timeout(modal.destroy, 10);
    };

    const init = () => {
      loadMerchantProfile();
      this.loader = true;
      MessageOutboundService.getMessagesListing(this.userContext,this.listing_mode).then((response) => {
        console.log( response );
        messages = response.response;
        this.pagination.elementsCount = messages.length;
        this.changePage();
      }).finally(() => {
        this.loader = false;
      });
    };

    this.$onInit = init;
  }
}

export default historyMessageController;



/** WEBPACK FOOTER **
 ** ./client/app/components/messageOutbound/history/history.controller.js
 **/